import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));
const DetailPage = lazy(() => import("./Pages/Detail"));

export const newsRoutes = [
  {
    page: MainPage,
    path: pathRoutes.news.parameter,
    screenCode: SCREEN.IP_008,
  },
  {
    page: DetailPage,
    path: pathRoutes.news.detail.parameter,
    screenCode: SCREEN.IP_009,
  },
];
